import { message, Switch } from 'antd';
import React, { Component } from 'react';
import VehiclePartnerApi from '../../functions/api/partner/VehiclePartner';

export default class ButtonHide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehiclePart: props.row,
      check: props.row.vhc_part_hide,
    };
  }

  componentWillReceiveProps(next) {
    this.setState({ vehiclePart: next.row, check: next.row.vhc_part_hide });
  }

  handleChangeHide = async (checked, row) => {
    this.setState({ check: checked });
    var value = await VehiclePartnerApi.updateSimple(
      this.state.vehiclePart.vhc_part_id,
      checked
    );
    if (!value || value['message']) {
      message.error('Không thể thay đổi trạng thái xe!');
    }
  };

  render() {
    return (
      <Switch onChange={this.handleChangeHide} checked={this.state.check} />
    );
  }
}
